export enum CharacterEnum {
  Comma = ',',
  Semicolon = ';',
  Slash = '/',
  Pipe = '|',
}
